// extracted by mini-css-extract-plugin
export default {"logo":"Signup_logo__vcJuM","main":"Signup_main__pUnWI","cta":"Signup_cta__HXOgu","terms":"Signup_terms__ZCmYf"};